import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import './index.scss';

type Props = {
    isOpen: boolean;
    onClose: () => void;
    language: string;
};

export const DisclaimerModal: FunctionComponent<Props> = ({
    isOpen,
    onClose,
    language,
}) => {
    const { t } = useTranslation();

    if (!isOpen) return null;

    return (
        <>
            <div
                className="modal-overlay"
                onClick={onClose}
                onKeyDown={e => {
                    if (e.key === 'Escape') onClose();
                }}
                role="button"
                tabIndex={0}
                aria-label="Close disclaimer"
            />
            <div className={`disclaimer-modal ${language}`}>
                <div className="disclaimer-content">
                    <p>{t('home.disclaimer.text')}</p>
                    <button
                        type="button"
                        className="disclaimer-button"
                        onClick={onClose}
                        aria-label={t('home.disclaimer.button')}
                    />
                </div>
            </div>
        </>
    );
};
